module.exports = __webpack_public_path__ + "img/1.653c2856.jpg";